import { cn } from "@/lib/utils";
import type { AlertLevel } from "@cold-crew/shared";

const CONFIG: Record<AlertLevel, { label: string; className: string; dot: string }> = {
  ok:       { label: "OK",       dot: "bg-emerald-500", className: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/30 dark:text-emerald-400" },
  amarillo: { label: "Bajo",     dot: "bg-yellow-500",  className: "bg-yellow-50 text-yellow-700 dark:bg-yellow-950/30 dark:text-yellow-400"    },
  rojo:     { label: "Crítico",  dot: "bg-red-500",     className: "bg-red-50 text-red-700 dark:bg-red-950/30 dark:text-red-400"                },
};

export function AlertaBadge({ nivel, className }: { nivel: AlertLevel; className?: string }) {
  const cfg = CONFIG[nivel];
  return (
    <span className={cn("inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium", cfg.className, className)}>
      <span className={cn("size-1.5 rounded-full", cfg.dot)} />
      {cfg.label}
    </span>
  );
}
